import React, { use, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../services/axios';
import Spinner from '../../components/loader/Spinner';
import { getInitials } from '../../utils/helper';
import moment from 'moment';
import Models from '../../components/common/Models';
import { toast } from 'react-toastify';

export default function EmployeeCallNotes() {
    const [notes, setNotes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [taskFormData, setTaskFormData] = useState({
        title: '',
        description: '',
        priority: 'MEDIUM',
        dueDate: '',
        status: 'PENDING'
    });
    const [taskLoading, setTaskLoading] = useState(false);
    const location =  useLocation();
    const id = location.pathname.split("/").pop();

    const fetch = async()=>{
        setLoading(true);
        try {
            const response = await axiosInstance.get(`/call-collections/call-notes/${id}`);
            setNotes(response.data.data);
            console.log("Fetched call notes:", response.data.data);
        } catch (error) {
            console.error("Error fetching call notes:", error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetch();
    },[])

    const renderProfileImage = (employee) => {
        if (employee.profileImg && employee.profileImg.startsWith('http')) {
            return (
                <img 
                    src={employee.profileImg}
                    alt={employee.name}
                    className="w-10 h-10 rounded-full object-cover"
                />
            );
        } else {
            return (
                <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm">
                    {getInitials(employee.name)}
                </div>
            );
        }
    };

    const handleCreateTask = (employee) => {
        setSelectedEmployee(employee);
        setTaskFormData({
            title: `Follow up on call notes - ${employee.name}`,
            description: '',
            priority: 'MEDIUM',
            dueDate: '',
            status: 'PENDING'
        });
        setIsTaskModalOpen(true);
    };

    const handleTaskSubmit = async (e) => {
        e.preventDefault();
        if (!selectedEmployee) return;

        setTaskLoading(true);
        try {
            await axiosInstance.post('/todos', {
                ...taskFormData,
                assignedTo: selectedEmployee.id
            });
            toast.success('Task created successfully');
            resetTaskForm();
        } catch (error) {
            toast.error('Failed to create task');
        } finally {
            setTaskLoading(false);
        }
    };

    const resetTaskForm = () => {
        setTaskFormData({
            title: '',
            description: '',
            priority: 'MEDIUM',
            dueDate: '',
            status: 'PENDING'
        });
        setSelectedEmployee(null);
        setIsTaskModalOpen(false);
    };

  return (
    <>
    {
        loading ? (
            <Spinner />
        ) : (
            <div className=" mx-auto p-4">
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
                    <div className="border-b border-gray-200 dark:border-gray-700 p-4 flex justify-between items-center">
                        <div>
                            <h2 className='text-2xl font-semibold text-gray-800 dark:text-gray-200'>Call Notes</h2>
                            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                                {notes.length} {notes.length === 1 ? 'note' : 'notes'} in this conversation
                            </p>
                        </div>
                        {notes.length > 0 && (
                            <button
                                onClick={() => handleCreateTask(notes[0].employee)}
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm flex items-center gap-2"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                </svg>
                                Create Task
                            </button>
                        )}
                    </div>

                    <div className="p-4">
                        {notes.length > 0 ? (
                            <div className="space-y-4 max-h-96 overflow-y-auto">
                                {notes.map((note, index) => (
                                    <div key={note.id || index} className="flex space-x-3">
                                        <div className="flex-shrink-0">
                                            {renderProfileImage(note.employee)}
                                        </div>
                                        
                                        <div className="flex-1 min-w-0">
                                            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-3 shadow-sm">
                                                <div className="flex items-center justify-between mb-2">
                                                    <div className="flex items-center space-x-2">
                                                        <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                                                            {note.employee.name}
                                                        </h4>
                                                        <span className="text-xs text-gray-500 dark:text-gray-400">
                                                            {note.employee.phone}
                                                        </span>
                                                    </div>
                                                    <div className="flex items-center space-x-2">
                                                        <span className="text-xs text-gray-500 dark:text-gray-400">
                                                            {moment(note.createdAt || note.createAt).format('MMM DD, YYYY HH:mm')}
                                                        </span>
                                                        <button
                                                            onClick={() => handleCreateTask(note.employee)}
                                                            className="text-blue-500 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 p-1 rounded"
                                                            title="Create task for this employee"
                                                        >
                                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                                
                                                <div className="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                                                    {note.callRemarks}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-8">
                                <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
                                    <svg className="w-8 h-8 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                                    </svg>
                                </div>
                                <p className="text-gray-500 dark:text-gray-400 text-lg">No call notes available</p>
                                <p className="text-gray-400 dark:text-gray-500 text-sm mt-1">Notes will appear here when added</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
    {/* Create Task Modal */}
    <Models isOpen={isTaskModalOpen} isClose={resetTaskForm}>
        <div className="p-6 max-w-2xl w-full bg-white dark:bg-gray-800">
            <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-gray-100">
                Create Task for {selectedEmployee?.name}
            </h2>
            <form onSubmit={handleTaskSubmit}>
                <div className="grid grid-cols-1 gap-4">
                    <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">Task Title *</label>
                        <input
                            type="text"
                            value={taskFormData.title}
                            onChange={(e) => setTaskFormData({...taskFormData, title: e.target.value})}
                            className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            placeholder="Enter task title"
                            required
                        />
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">Description</label>
                        <textarea
                            value={taskFormData.description}
                            onChange={(e) => setTaskFormData({...taskFormData, description: e.target.value})}
                            className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg h-24 focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            placeholder="Enter task description"
                            required
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">Priority *</label>
                            <select
                                value={taskFormData.priority}
                                onChange={(e) => setTaskFormData({...taskFormData, priority: e.target.value})}
                                className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            >
                                <option value="LOW">Low</option>
                                <option value="MEDIUM">Medium</option>
                                <option value="HIGH">High</option>
                                <option value="URGENT">Urgent</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">Due Date</label>
                            <input
                                type="date"
                                value={taskFormData.dueDate}
                                onChange={(e) => setTaskFormData({...taskFormData, dueDate: e.target.value})}
                                className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                                min={moment().format('YYYY-MM-DD')}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">Assigned To</label>
                        <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600">
                            <div className="flex items-center space-x-3">
                                <div className="flex-shrink-0">
                                    {selectedEmployee && renderProfileImage(selectedEmployee)}
                                </div>
                                <div>
                                    <p className="font-medium text-gray-900 dark:text-gray-100">{selectedEmployee?.name}</p>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">{selectedEmployee?.email}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end gap-2 mt-6">
                    <button
                        type="button"
                        onClick={resetTaskForm}
                        className="px-6 py-2 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-400 dark:hover:bg-gray-500 transition-colors"
                        disabled={taskLoading}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50"
                        disabled={taskLoading}
                    >
                        {taskLoading ? 'Creating...' : 'Create Task'}
                    </button>
                </div>
            </form>
        </div>
    </Models>
    </>
  )
}
